export default __webpack_public_path__ + "static/media/extramarks-smart-classes-500x500.107c4849.svg";